<ng-container >
    <button class="pn-button pn-button-primary move-control-button" type="button" [disabled]="taskMovementService.isUpdateStateDisable" (click)="showStatePopup = true">
        Update State
    </button>
</ng-container>

<!-- Update-State-Form-Component -->

@if(showStatePopup) {
    <p-dialog header="Update Task State" [(visible)]="showStatePopup" [modal]="true" [closable]="true"
        [style]="{ width: '50vw'}" (onHide)="showStatePopup = false" [appendTo]="'body'">
        <app-update-state-form #updateState (statusSubmitted)="handleStateUpdate($event)"></app-update-state-form>
        <ng-template #footer>
            <ng-container *ngTemplateOutlet="updateState.updateStateFooter"></ng-container>
        </ng-template>
    </p-dialog>
}